import classes from './SubSectionWrapper.module.css';
import ActionIcon from '@/components/ActionIcon';

type Props = {
  children: React.ReactNode;
  onGoBack: () => void;
  title: string;
};

const SubSectionWrapper = ({ children, onGoBack, title }: Props) => {
  return (
    <article className={classes.root}>
      <header>
        <ActionIcon
          className={classes.chevronLeft}
          name="feather/chevron-left"
          onClick={onGoBack}
          label="Go back"
          size="lg"
        />
        <h2 className={classes.title}>{title}</h2>
      </header>
      <section className={classes.stackedPreferences}>{children}</section>
    </article>
  );
};

export default SubSectionWrapper;
